export const REQUESTS = {
  LOGIN: '/authenticate',
  CHECK_TICKET: '/checkTicket',
  VALIDATE_TICKET: '/validateTicket'
};